import type { ColDef } from "ag-grid-enterprise";
import { HALF_YEAR_KEYS } from "../../../../utils/timePeriodUtils";
import type { CalendarType, TimePeriodColumnOptions } from "../columnFactory";
import { baseTimePeriodProperties } from "./baseTimePeriodProperties";
import { getEditableByPlanBy } from "./editableByPlanBy";

/**
 * Creates the 2 half-year column definitions (H1–H2).
 * Half-year columns are only editable for the inventory_454 calendar type.
 */
export function createHalfYearlyColumns(
  calendarType: CalendarType,
  options: TimePeriodColumnOptions
): ColDef[] {
  const {
    planBy,
    planningYear,
    metaData,
    intake,
    editableProducer,
    editableRowPredicate,
    editableMetricsOverride,
    editableTimeWindowPredicate,
    cubeWindow
  } = options;
  const base = baseTimePeriodProperties(
    planBy,
    planningYear,
    metaData,
    cubeWindow,
    editableTimeWindowPredicate !== undefined
  );
  const editable =
    planBy === "SH%" || calendarType !== "inventory_454"
      ? false
      : getEditableByPlanBy({
          planBy,
          planningYear,
          metaData,
          intake,
          editableProducer,
          editableRowPredicate,
          editableMetricsOverride,
          editableTimeWindowPredicate,
          cubeWindow
        });

  return HALF_YEAR_KEYS.map((fieldId) => ({
    ...base,
    field: fieldId,
    headerName: metaData.gregMapping[fieldId] ?? fieldId,
    headerTooltip: fieldId,
    editable
  }));
}
